import { render } from "./MyCalendar.vue?vue&type=template&id=53a43dd9"
import script from "./MyCalendar.vue?vue&type=script&lang=js"
export * from "./MyCalendar.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./MyCalendar.vue?vue&type=style&index=0&id=53a43dd9&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__